/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-mate.agent-message.error': '重新載入聊天',
  'ai-mate.agent-message.error.aup-link-text': '可接受使用政策﻿',
  'ai-mate.agent-message.error.aup-one': '我們無法回應該提示。',
  'ai-mate.agent-message.error.aup-two': '您的提示可能不符合我們的{link}。請嘗試其他提示。',
  'ai-mate.agent-message.error.copy-trace-id': '複製追蹤 ID',
  'ai-mate.agent-message.error.network-error': '似乎有網絡問題。',
  'ai-mate.agent-message.error.resend': '重新傳送訊息',
  'ai-mate.agent-message.error.trace-id': '追蹤 ID：{traceId}',
  'ai-mate.browse-agents-view.close-button': '關閉客服人員檢視',
  'ai-mate.browse-agents-view.header-title': '瀏覽客服人員',
  'ai-mate.chat-history.conversationLimit':
    '正在尋找舊的聊天內容嗎？我們在 30 天後會清除聊天記錄，以確保 AI 可順暢執行。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': '我最近為哪些 Confluence 頁面做出貢獻？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': '找到指派給我的所有 Jira 工單。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': '我們的旅遊政策是什麼？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4': '為行銷活動草擬 Confluence 頁面。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': '如何建立專案時間軸？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': '寫一封跟進電子郵件給潛在客戶。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-7': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-1': '`人員` 所撰寫的提取要求是什麼？',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-2': '目前 Jira 衝刺尚未解決的提取要求是什麼？',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-3': '`Jira 工作項目` 已經部署了嗎？',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': '瀏覽客服人員',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': '與 Rovo 客服人員聊天',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': '關於這個空間',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': '關於這個空間的深入解析',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': '空間建議',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1': '我撰寫的頁面上有什麼新活動嗎？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10': '`有人` 在我發布的頁面上留言嗎？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': '「頁面」中的主要重點是什麼？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-12': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': '有沒有新的留言提及我？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3': '摘要此空間中最近發布的頁面。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4': '摘要我自上週以來對頁面的貢獻。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5': '您可以透過更簡單易懂的方式撰寫此 `頁面` 嗎？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6': '針對專案管理建立遊戲規劃範本。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7': '我們對常見的客戶問題有什麼研究？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8': '我的團隊中是否有任何人在本週發布新頁面？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': '`有人` 在本週發布了新頁面嗎？',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': '您可以改善此頁面上的文字嗎？',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': '為此頁面撰寫執行摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': '給我一些其他相關頁面的連結。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-4': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': '關於此頁面',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': '此頁面的更多資訊',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': '頁面建議',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': '將我正在閱讀的內容做摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': '將此頁面上的留言做摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3': '把我當成初學者，向我解釋此頁面。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4': '誰撰寫了這個頁面，以及撰寫者屬於哪一個團隊？',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5': '此頁面在上週有什麼變更嗎？',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-6': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': '關於此白板',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': '來自此白板的更多內容',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': '此白板上的深入解析',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': '將我正在閱讀的內容做摘要。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-4': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2': '醒目顯示在此處可見的任何模式或趨勢。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3': '識別在此白板中擷取的任何關鍵交辦事項或決策。',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': '保持生產力',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': '草擬內容',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': '尋找資訊',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': '尋找人員',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': '取得答案',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': '測量生產力',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': '換個方式描述內容',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': '保持最新狀態',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': '建立內容摘要',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>建立者為</text> {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': '{userName}，您好',
  'ai-mate.chat-history.empty-state.intro-text-link-text': '探索 Rovo Chat 和客服人員',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': '選擇對話啟動方式，或詢問任何問題。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': '尋找本週更新的 Jira 議題。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh': '尋找本週更新的 Jira 工作項目。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': '哪些 Jira 議題有最高的優先順序？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh': '哪些 Jira 工作項目有最高的優先順序？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': '哪些 Jira 議題的留言有提到我？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh': '哪些 Jira 工作項目的留言有提及我？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': '針對 `Jira 議題` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh': '針對 `Jira 工作項目` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': '為使用者案例建立描述範本。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-6': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': '關於此議題',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': '關於此工作項目',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': '此議題的更多資訊',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': '此工作項目的更多資訊',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': '有關此議題的深入解析',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': '有關此工作項目的深入解析',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': '議題建議',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': '工作項目建議',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': '有沒有與此類似的 Jira 議題？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh': '有沒有與此類似的 Jira 工作項目？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': '如何改善描述？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': '我可以將哪些標籤新增至此議題？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh': '我可以將哪些標籤新增至此工作項目？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-4': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': '關於此專案',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': '有關此專案的深入解析',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': '此專案的更多資訊',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': '專案建議',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': '哪一項工作已經有一陣子沒有進展？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': '尋找類似的 Jira 議題並加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh': '尋找類似的 Jira 工作項目並加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11': '是否有任何 Jira 議題並未連結至父系議題？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    '是否有任何 Jira 工作項目並未連結至父系工作項目？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12': '調整 `Jira 議題` 描述以符合最佳做法。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    '調整 `Jira 工作項目` 描述以符合最佳做法。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': '針對 `Jira 議題` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    '針對 `Jira 工作項目` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': '為使用者案例建立描述範本。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh': '為使用者案例建立描述範本。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-15': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': '有任何 Jira 議題被封鎖嗎？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh': '有任何 Jira 工作項目被封鎖嗎？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3': '列出目前「進行中」的 Jira 議題，並按受託人加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    '列出目前「進行中」的 Jira 工作項目，並按受託人加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': '有多少議題指派給 `某人`？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh': '有多少工作項目指派給「某人」？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5': '是否 `有人` 在此衝刺中的 Jira 議題上留言？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    '是否有 `人員` 在此衝刺中的 Jira 工作項目上留言？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': '哪些 Jira 議題並未指派？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh': '哪些 Jira 工作項目並未指派？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': '哪些 Jira 議題處於待處理狀態最久？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh': '哪些 Jira 工作項目處於待處理狀態最久？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': '誰有最多任務？',
  'ai-mate.chat-history.empty-state.message': '獲得答案、產生新構想，並加速日常工作。',
  'ai-mate.chat-history.empty-state.suggestion1': '我是否有任何過期的工單？',
  'ai-mate.chat-history.empty-state.suggestion2': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.suggestion3': '撰寫本週更新',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': '建議',
  'ai-mate.chat-history.message-post-research.title': '研究完成',
  'ai-mate.chat-history.message-pre-research.title': '建立研究計畫',
  'ai-mate.chat-history.message-research-notification-button-text': '完成時通知我',
  'ai-mate.chat-history.message-research-notification-confirmation-label-text': '完成後我們會通知您',
  'ai-mate.chat-history.message-research-notification-text':
    '深入研究可能需要幾分鐘的時間，但結果值得等待。您可以繼續工作，只需將此聊天視窗保持開啟即可。',
  'ai-mate.chat-history.message-research.research-completed-notification-body': '您的研究已完成，可供檢視。',
  'ai-mate.chat-history.message-research.research-completed-notification-title': 'Rovo Chat 已完成研究',
  'ai-mate.chat-history.message-research.research-expandable.collapse': '摺疊',
  'ai-mate.chat-history.message-research.research-expandable.expand': '展開',
  'ai-mate.chat-history.message-research.research-step-title-placeholder': '搜尋相關資訊...',
  'ai-mate.chat-history.message-research.sources-title': '{count, plural, other {{count} 個來源}}',
  'ai-mate.chat-history.message-research.step-loaded-icon-label': '已載入步驟',
  'ai-mate.chat-history.message-research.step-loading-icon-label': '正在載入步驟',
  'ai-mate.chat-history.message-research.title.v2': '顯示研究活動',
  'ai-mate.chat-history.message-research.view-sources-button-label': '{count, plural, other {{count} 個來源}}',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': '取消',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': '確認',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button': '完成此動作時發生問題',
  'ai-mate.chat-input.actions-button.label': '插入元素',
  'ai-mate.chat-input.add-a-link-button.label': '新增連結',
  'ai-mate.chat-input.chat-input-assistive-label': '撰寫提示以開始使用',
  'ai-mate.chat-input.deep-research-button.label': '深入研究',
  'ai-mate.chat-input.deleted-agent-icon-label': '已刪除客服人員',
  'ai-mate.chat-input.deleted-agent-start-new-chat': '開始新聊天',
  'ai-mate.chat-input.deleted-agent-warning': '此客服人員已被刪除。',
  'ai-mate.chat-input.dr.disabled.tooltip': '目前，客服人員無法使用深入研究。',
  'ai-mate.chat-input.drag-and-drop-message': '拖放以新增背景資訊，用於取得更好的結果',
  'ai-mate.chat-input.file-close-icon-label': '移除檔案',
  'ai-mate.chat-input.link-type-ahead-button.label': '新增連結',
  'ai-mate.chat-input.mention-someone-button.label': '提及某人或團隊',
  'ai-mate.chat-input.mention-type-ahead-button.label': '提及某人',
  'ai-mate.chat-input.notifications-enabled': '已啟用通知',
  'ai-mate.chat-input.notifications-enabled-body': '您可以繼續在另一個分頁中工作，我們將在您的研究完成時通知您！',
  'ai-mate.chat-input.notifications-enabled-button': '啟用通知',
  'ai-mate.chat-input.notifications-enabled-notification-content': '您的深度研究查詢完成後，將會收到通知。',
  'ai-mate.chat-input.notifications-enabled-notification-title': '通知已啟用！',
  'ai-mate.chat-input.notifications-not-enabled': '未啟用通知',
  'ai-mate.chat-input.notifications-not-enabled-body':
    '深度研究很強大，但可能需要更長時間才能完成。如果您啟用通知，可以繼續在另一個分頁中工作，完成後我們會通知您！',
  'ai-mate.chat-input.open-chat-input-buttons-label': '打開聊天輸入的按鈕',
  'ai-mate.chat-input.search.disabled.tooltip': '目前，客服人員無法使用網頁搜尋。',
  'ai-mate.chat-input.send-button.label': '提交',
  'ai-mate.chat-input.stop-generating-button.label': '停止產生',
  'ai-mate.chat-input.store-user-messages.label': '記錄此訊息以協助我們改善回答品質',
  'ai-mate.chat-input.web-search-button.label': '搜尋',
  'ai-mate.chat-main-header.back-button.label': '返回',
  'ai-mate.chat-main-header.copy-agent-link-button.label': '複製連結',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.body':
    '正在進行深入研究。如果您繼續操作，我們將無法在背景中處理您的提示。',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.button': '關閉聊天',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.cancel-button': '取消',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.close-button': '關閉',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.title': '關閉聊天',
  'ai-mate.chat-main-header.default-agent-name': '聊天',
  'ai-mate.chat-main-header.edit-agent-button.label': '編輯',
  'ai-mate.chat-main-header.link-copied-to-profile': '已複製 URL',
  'ai-mate.footer.footer-message': '使用人工智慧。驗證結果。',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': '確認失敗，請稍後再試一次。',
  'ai-mate.pubsub-listener.forge-auth-success-message': '確認成功，請重新傳送提示。',
  'ai-mate.sidebar.agents-icon.text': '客服人員',
  'ai-mate.sidebar.agents-icon.tooltip': '瀏覽 Rovo 客服人員',
  'ai-mate.sidebar.chat-icon.text': '聊天',
  'ai-mate.sidebar.chat-icon.tooltip': '與 Rovo 聊天',
  'ai-mate.sidebar.debug-mode-icon.tooltip': '除錯',
  'ai-mate.sidebar.get-help-icon.tooltip': '取得協助',
  'ai-mate.sidebar.give-feedback-icon.tooltip': '提供意見反應',
  'ai-mate.sidebar.history-icon.text': '歷程記錄',
  'ai-mate.sidebar.history-icon.tooltip': '檢視您的聊天歷史記錄',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-description': '驗證檔案時發生錯誤，請再試一次。',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-title': '無法驗證檔案',
  'ai-mate.upload-files-to-conversation.file-invalid-icon-label': '檔案無效',
  'ai-mate.upload-files-to-conversation.invalid-files-description':
    '{count, plural, other {不支援下列檔案：「{fileNames}」。原因：{reasons}}}',
  'ai-mate.upload-files-to-conversation.invalid-files-title':
    '{count, plural, other {不支援 {count,number} 個檔案類型}}',
  'ai-mate.upload-files-to-conversation.unknown-error': '上傳檔案時發生錯誤。請再試一次。',
  'ai-mate.upload-files-to-conversation.unsupported-file': '不支援的檔案類型',
  'ai-mate.upload-files-to-conversation.validation-error-file-name-missing': '缺少檔案名稱',
  'ai-mate.upload-files-to-conversation.validation-error-file-too-large': '檔案大小太大',
  'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type': '不支援檔案類型',
  'ai-mate.upload-files-to-conversation.validation-error-missing-error-code': '驗證結果未知',
  'ai-mate.upload-files-to-conversation.validation-error-not-found': '找不到驗證結果',
  'ai-mate.upload-files-to-conversation.validation-error-unknown-error': '由於未知原因，無法驗證檔案',
  'chat-history.deep-research-rate-limit-warning': '請在 24 小時後再試一次。',
  'chat-history.deep-research-rate-limit-warning-description': '您已超過深度研究的速率上限。請在 24 小時後再試一次。',
  'chat-history.rate-limit-warning': '{secondsRemaining, plural, other {請等待 {secondsRemaining,number} 秒}}',
  'chat-history.rate-limit-warning-description': '訊息傳送過快，請稍候。',
  'chatHistory.storeAssistant.badResponseLabel': '回應不良',
  'chatHistory.storeAssistant.copyResponseLabel': '複製',
  'chatHistory.storeAssistant.goodResponseLabel': '回應良好',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': '使用此背景資訊',
  'rovo-chat.data-sculptor-modal.cancel': '取消',
  'rovo-chat.data-sculptor-modal.no-data': '無資料',
  'rovo-chat.data-sculptor-modal.title': '分析',
  'rovo-chat.file-upload-button.label': '上傳檔案',
  'rovo-chat.file-upload-button.max-files-label': '{maxFiles, plural, other {已達到 {maxFiles,number} 個檔案的上限}}',
  'rovo-chat.store-assistant.beta-features-message': '提供的答案使用了測試版功能。',
  'rovo-chat.store-assistant.beta-lozenge': '測試版',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': '插入到頁面',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': '插入',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': '插入至議題',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': '取代所選範圍',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    '您目前的背景資訊不支援此功能。請嘗試選取、撰寫或編輯頁面上的文字。',
  'rovo-chat.store-assistant.sources-title': '來源：',
};
